import React from "react";
import "../css/GenericModal.css";

// className opcional vai para o conteúdo (ex.: "modal-detalhes" estiliza só a janela de detalhes
// do restaurante); sem ele o modal fica exatamente como antes nas telas do admin.
const Modal = ({ isOpen, onClose, className = "", children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay show">
      <div className={`modal-content ${className}`.trim()} role="dialog" aria-modal="true">
        <button className="close-button" onClick={onClose} aria-label="Fechar">
          X
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
